
export default {
    namespaced: true,
    state: {
        goods: [
        ],
        currentSort:'id',
        currentSortDir:'asc',
        pageSize:26,
        currentPage:1,
        countRow: 0,

        filterData: {},
        rangeFilterData: {},

        siteFilter: false,
        groupFilter: false,
        nameFilter: false,
        idFilter: false,
        idToFilter: false,
        affiliateField: {},
        exportList: [],
        fieldsList: []

    },
    getters: {
        FIELDS_LIST: state => {
            return state.fieldsList;
        },
        EXPORT_LIST: state => {
            return state.exportList;
        },
        AFFILIATE_FIELD: state => {
            return state.affiliateField;
        },
        GOODS_LIST: state => {
            return state.goods;
        },
        FILTER_DATA: state => {
            return state.filterData;
        },
        RANGE_FILTER_DATA: state => {
            return state.rangeFilterData;
        },
        CURRENT_SORT: state => {
            return state.currentSort;
        },
        COUNT_ROW: state => {
            return state.countRow;
        },
        ID_FILTER: state => {
            return state.idFilter;
        },
        NAME_FILTER: state => {
            return state.nameFilter;
        },
        CURRENT_SORT_DIR: state => {
            return state.currentSortDir;
        },
        PAGE_SIZE: state => {
            return state.pageSize;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        SITE_FILTER: state => {
            return state.siteFilter;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.countRow/state.pageSize);
        }
    },
    mutations: {
        FIELDS_LIST: (state, payload) => {
            return state.fieldsList = payload;
        },
        EXPORT_LIST: (state, payload) => {
            return state.exportList = payload;
        },
        AFFILIATE_FIELD: (state, payload) => {
            return state.affiliateField = payload;
        },
        CURRENT_SORT_DIR: (state, payload) => {
            return state.currentSortDir = payload;
        },
        CURRENT_SORT: (state, payload) => {
            return state.currentSort = payload;
        },
        FILTER_DATA: (state, payload) => {
            return state.filterData = payload;
        },
        RANGE_FILTER_DATA: (state, payload) => {
            return state.rangeFilterData = payload;
        },
        SET_GOODS: (state, payload) => {
            return state.goods = payload;
        },
        SET_COUNT_ROW: (state, payload) => {
            return state.countRow = payload;
        },
        PAGE_SIZE: (state, payload) => {
            return state.pageSize = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        }
    },
    actions: {
        GET_ALL: async ({state, commit}, payload) => {
            let params = {
                'page': state.currentPage,
                'pageSize': state.pageSize <= 0 ? 1 : state.pageSize,
                'filters': JSON.stringify(state.filterData),
                'rangeFilter': JSON.stringify(state.rangeFilterData),
                'sort': state.currentSort,
                'sortDir': state.currentSortDir
            };
            let createParamsUrl = function (params) {
                let urlParams = [];
                for (let prop in params) {
                    if (params[prop] !== false && params[prop] !== '') {
                        urlParams.push(prop +'='+ encodeURIComponent(params[prop]));
                    }
                }
                return '?'+ urlParams.join('&');
            }
            let urlParams = createParamsUrl(params);

            payload.th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/goods-list' + urlParams,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('SET_GOODS', responseData.data.list);
                    commit('SET_COUNT_ROW', responseData.data.count);
                    commit('FIELDS_LIST', responseData.data.fieldsList);
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },
        EXPORT_SAVE: async ({state, dispatch}, payload) => {
            let selectParams = {
                'filters': JSON.stringify(state.filterData),
                'rangeFilter': JSON.stringify(state.rangeFilterData),
                'sort': state.currentSort,
                'sortDir': state.currentSortDir
            };
            let params = {
                'exportName': payload.th.exportName,
                'exportParams': {
                    'selectParams': selectParams,
                    'affiliateField': payload.th.affiliateField,
                    'separator': payload.th.selectedSeparator,
                    'includeFirstRow': payload.th.includeFirstRow
                }
            };
            var th = payload.th;
            if (payload.execute) {
                th.isExporting = true;
            } else {
                th.isSaving = true;
            }
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/goods-export/save',
                parameter: params,
                th: th,
                getResponse: () => {
                    th.isSaving = false;
                    th.isExporting = false;
                },
                getSuccessResponse: (responseData) => {
                    th.exportName = '';
                    if (th.andExecute) {
                        th.andExecute = responseData.exportId;
                    }
                    dispatch('EXPORT_LIST_UPDATE', {th: th});
                }
            });
        },
        EXPORT_LIST_UPDATE: async ({commit}, payload) => {
            var th = payload.th;
            th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/goods-export',
                th: th,
                showSuccessMessage: false,
                getSuccessResponse: function (responseData) {
                    commit('EXPORT_LIST', responseData.data);
                    if (th.andExecute) {
                        setTimeout(() => {th.executeExportById()}, 1000);
                    }
                },
                getResponse: () => {
                    th.showOverlay = false;
                },
            });
        },
        EXPORT_DELETE: async ({dispatch}, payload) => {
            var th = payload.th;
            var ref = payload.ref;

            th.$refs[ref][0].classList.add('toggle');
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/goods-export/delete/'+ payload.id,
                th: th,
                getResponse: () => {
                    th.$refs[ref][0].classList.remove('toggle');
                },
                getSuccessResponse: (responseData) => {
                    console.log(responseData);
                    dispatch('EXPORT_LIST_UPDATE', {th: th});
                }
            });
        },
    }
}